import React from "react";
import { Stack } from "@mui/material";

import Logo from "../../../shared/Logo/Logo";
import ProgressBar from "../../../UI/ProgressBar/ProgressBar";
import LoadingComponent from "../../../UI/LoadingBar/LoadingBar";
import HeaderBarcode from "../../../shared/HeaderBarcode/HeaderBarcode";
import FooterBarcode from "../../../shared/FooterBarcode/FooterBarcode";

import "./M3Loading.scss";

const M3Loading = ({ progress, loaded }) => {
  return (
    <Stack className="m3-loading-screen">
      <Stack className="dotted-background">
        <ProgressBar
          progress={progress}
          label={loaded ? "Ready" : "Loading assets..."}
        />
        <Stack direction={"column"} className="container header">
          <HeaderBarcode />
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          className="container content"
          spacing={2}
        >
          <div className="question-bubble">Where did it come from?</div>

          <LoadingComponent />

          <Stack className="mission-info">
            <div className="mission-number">Mission 3</div>
            <div className="mission-status">Digital Breadcrumbs</div>
            <div className="mission-description">
              Identify previous location visited...
            </div>
          </Stack>
        </Stack>
        <Stack direction={"row"} className="container footer">
          <Logo />
          <FooterBarcode />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default M3Loading;
